import * as types from "../../actions/actionTypes";

const INITIALIZED_MODAL_DATA = {
  title: "",
  reasonObject: {},
  actionType: ""
};
const INITIALIZED_CONFIRM = {
  show: false,
  message: "",
  action: "",
  confirmOrWarningType: ""
};
const initialState = {
  modalData: INITIALIZED_MODAL_DATA,
  modalStatus: false,
  confirm: INITIALIZED_CONFIRM
};

const PettyCash = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_REASON_PAGE_MODAL_DATA:
      return {
        ...state,
        modalData: action.data,
        modalStatus: true
      };
    case types.CLOSE_REASON_PAGE_MODAL_DATA:
      return {
        ...state,
        modalData: INITIALIZED_MODAL_DATA,
        modalStatus: false
      };
    case types.SET_PETTY_CASH_CONFIRM_DATA:
      return {
        ...state,
        confirm: action.data
      };
    case types.CLOSE_PETTY_CASH_CONFIRM_DATA:
      return {
        ...state,
        confirm: INITIALIZED_CONFIRM
      };
    default:
      return state;
  }
};

export default PettyCash;
